export { default } from './Collapse'; // eslint-disable-next-line camelcase

export { default as unstable_StrictModeCollapse } from './StrictModeCollapse';